<template>
  <div class="Help">
    <section-header heading="2" ja="クーポンを使いたいプリクラ機を選んでね"/>
    <normal-btn @click="onTotolu">totolu</normal-btn>
    <normal-btn @click="onGIMMI">GIMMI</normal-btn>
    <normal-btn @click="onRomakyun">romakyun</normal-btn>
    <normal-btn @click="onLalamee">lalamee</normal-btn>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "Help",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  computed: {
  },
  mounted () {
    sessionStorage.setItem('prevPage', '/couponHelp');
  },
  methods: {
    onTotolu() {
      this.$router.push("/AboutTotolu03")
    },
    onGIMMI(){
      this.$router.push("/AboutGimmi03")
    },
    onRomakyun() {
      this.$router.push("/AboutRomakyun03")
    },
    onIMyMerry() {
      this.$router.push("/AboutIMyMerry03")
    },
    onBepiu() {
      this.$router.push("/AboutBepiu03")
    },
    onROMAPI() {
      this.$router.push("/AboutRomapi03")
    },
    onLalamee() {
      this.$router.push("/AboutLalamee03")
    },
    onBack() {
        this.$router.push('/CouponList')
    }
  }
}
</script>

<style scoped>
</style>
